import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import {OverlayMarker} from 'common/components/BetterMap';
import styles from './VehicleOverlayMarker.css';

import LargeVehicleIcon from './LargeVehicleIcon';
import MediumVehicleIcon from './MediumVehicleIcon';
import SmallVehicleIcon from './SmallVehicleIcon';

const markerIcons = {
  small: SmallVehicleIcon,
  medium: MediumVehicleIcon,
  large: LargeVehicleIcon,
};

const markerAnchors = {
  small: {x: 10, y: 10},
  medium: {x: 18, y: 18},
  large: {x: 28.5, y: 28.5},
};

const normalizeHeading = heading => {
  if (heading < 0) return normalizeHeading(heading + 360);
  if (heading > 360) return normalizeHeading(heading - 360);
  return heading;
};

const updatedHeading = (prevHeading, heading) => {
  if (prevHeading === undefined || prevHeading === null) return heading;
  const difference = normalizeHeading(prevHeading) - heading;
  if (Math.abs(difference) <= 180) {
    return prevHeading - difference;
  } else if (normalizeHeading(prevHeading) > heading) {
    return prevHeading - difference + 360;
  }
  return prevHeading - difference - 360;
};

class VehicleOverlayMarker extends React.Component {
  static displayName = 'VehicleOverlayMarker';

  static propTypes = {
    color: PropTypes.string,
    callName: PropTypes.string,
    heading: PropTypes.number,
    onBreak: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    VehicleIcon: PropTypes.func,
    vehicleIconAnchor: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
    zIndex: PropTypes.number,
    onClick: PropTypes.func,
    animateHeading: PropTypes.bool,
    animateMovement: PropTypes.bool,
    animationDuration: PropTypes.number,
  };

  static defaultProps = {
    animateHeading: true,
    animateMovement: true,
    animationDuration: 6,
  };

  componentDidUpdate() {
    this.oldSize = this.props.size;
  }

  oldSize = null;

  render() {
    const {color, callName, heading, onBreak, onClick, size, ...rest} = this.props;
    this._heading = updatedHeading(this._heading, heading);
    this._animateHeading = this.props.animateHeading;
    const anchor = markerAnchors[size];
    const VehicleIcon = markerIcons[size];
    // Don't animate when resizing the icon, for whatever reason
    const animationDuration = this.props.size === this.oldSize && this.props.animateMovement ?
      this.props.animationDuration :
      0;
    return (
      <OverlayMarker anchor={anchor} animationDuration={animationDuration} {...rest}>
        <div
          className={classNames(styles.root, {[styles.clickable]: !!onClick})}
          data-id="vehicle-overlay-marker"
          onClick={onClick}
        >
          {callName &&
            <div className={styles.labelWrapper}>
              <div className={styles.label} style={{backgroundColor: color}}>{callName}</div>
            </div>}
          <VehicleIcon
            onBreak={onBreak}
            color={color}
            heading={this._heading}
            animateHeading={this._animateHeading}
          />
        </div>
      </OverlayMarker>
    );
  }
}

export default VehicleOverlayMarker;



// WEBPACK FOOTER //
// ./src/common/components/VehicleOverlayMarker/VehicleOverlayMarker.js